import {Floor} from "./floor";

export class ProjectTable {
     id: number;
     version: number;
     name: string;
     floors: Floor[] = [];
     tableHead: TableHeadRoom[] = [];
}

export interface ProjectTableResponse {
  table: ProjectTable;
  currentSystemDate: string | null;
}

export class TableHeadRoom {
  name: string;
  tradeName: string;
  areas: string[] = [];
  usageAmount = 1;
}
